export function createSingleton(factory, dbgGlobalName = null) {
    let instance = null;
    return function () {
        if (!instance) {
            instance = factory();
            if (dbgGlobalName && typeof window !== 'undefined') {
                window[dbgGlobalName] = instance;
            }
        }
        return instance;
    };
}
function makeId(ids) {
    return ids
        .map(id => {
        if (id === null || id === undefined || typeof id === 'string' || typeof id === 'number' || typeof id === 'boolean')
            return String(id);
        return JSON.stringify(id);
    })
        .join('-');
}
export function createObjectsCache(factory, dbgGlobalName = null) {
    const instanceCache = {};
    if (dbgGlobalName && typeof window !== 'undefined') {
        window[dbgGlobalName] = instanceCache;
    }
    const get = (...ids) => {
        const id = makeId(ids);
        if (id in instanceCache) {
            const obj = instanceCache[id];
            return obj.retain ? obj.retain() : obj;
        }
        else {
            const obj = factory(...ids); //                              
            instanceCache[id] = obj;
            return obj;
        }
    };
    const remove = (...ids) => {
        const id = makeId(ids);
        console.assert(id in instanceCache);
        delete instanceCache[id];
    };
    return { get, remove };
}
